import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import LaboratoryResultDescribe from './LaboratoryResultDescribe';
import { Size } from '../../../../Enums/Size.enum';
import { LaboratoryResultMise } from '../../../../graphql/graphql';

interface Props extends BaseModalProps {
	laboratoryResultMise: LaboratoryResultMise;
}

const LaboratoryResultDescribeModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.laboratoryResultsToDescribeListItem.laboratoryResults'
			size={Size.FULLSCREEN}>
			<LaboratoryResultDescribe
				laboratoryResultMise={props.laboratoryResultMise}
				onSuccess={props.onClose}
			/>
		</BaseModal>
	);
};

export default LaboratoryResultDescribeModal;
